module.exports = __webpack_public_path__ + "static/media/Calleb Osei.7f01eddf.jpg";